<template>
  <div class="kcm-group">
    <InnerHeader
      :cover="require('../../assets/img/kcm_group/cover.jpg')"
      :bgColor="'#164194'"
      :links="links"
      :fixedOnly="$route.query.page === 'companies' ? true : false"
      :backTo="$route.query.contacts ? '/contacts' : '/kcm-group'"
      :bgPosition="'0 20%'"
    />
    <Management v-if="!$route.query.page"/>
    <ExecutiveManagement v-else-if="$route.query.page === 'executive'"/>
    <Companies v-else-if="$route.query.page === 'companies'"/>
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import Management from './Management';
import ExecutiveManagement from './ExecutiveManagement';
import Companies from './Companies';
export default {
  components: {
    InnerHeader,
    Management,
    ExecutiveManagement,
    Companies
  },
  computed: {
    links() {
      return [
        {
          name: this.$t('nav2-1'),
          url: '/kcm-group'
        },
        {
          name: this.$t('nav2-2'),
          url: '/kcm-group?page=executive'
        },
        {
          name: this.$t('nav2-3'),
          url: '/kcm-group?page=companies',
          active: [
            '/kcm-group?page=companies&c=1',
            '/kcm-group?page=companies&c=2',
            '/kcm-group?page=companies&c=3',
            '/kcm-group?page=companies&c=4',
            '/kcm-group?page=companies&c=5',
            '/kcm-group?page=companies&c=6',
            '/kcm-group?page=companies&c=7',
            '/kcm-group?page=companies&c=8',
            '/kcm-group?page=companies&c=9',
            '/kcm-group?page=companies&c=10',
            '/kcm-group?page=companies&c=11',
            '/kcm-group?page=companies&c=12'
          ]
        }
      ];
    }
  },
  mounted() {
    document.title = this.$t('title2');
  },
  destroyed() {
    document.title = this.$t('title0');
  }
};
</script>

<style>
</style>
